import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function initPartnersListing(): void {
  const items  = document.querySelectorAll<HTMLElement>('.listing-item');
  const images = document.querySelectorAll<HTMLImageElement>('.sticky-partner-img');

  if (!items.length || !images.length) return;

  let currentIndex = 0;

  function showImage(index: number): void {
    if (index === currentIndex) return;

    gsap.to(images[currentIndex], {
      opacity: 0,
      duration: 0.2,
      ease: 'power2.out',
    });

    gsap.to(images[index], {
      opacity: 1,
      duration: 0.2,
      ease: 'power2.in',
    });

    currentIndex = index;
  }

  gsap.set(items[0], { opacity: 1 });

  items.forEach((item: HTMLElement, i: number) => {
    const index = parseInt(item.dataset.index ?? String(i), 10);

    ScrollTrigger.create({
      trigger: item,
      start: 'top 60%',
      end: 'bottom 40%',

      onEnter() {
        gsap.to(item, { opacity: 1, duration: 0.5, ease: 'power2.out' });
        showImage(index);
      },

      onEnterBack() {
        gsap.to(item, { opacity: 1, duration: 0.5, ease: 'power2.out' });
        showImage(index);
      },

      onLeave() {
        gsap.to(item, { opacity: 0.25, duration: 0.5, ease: 'power2.in' });
      },

      onLeaveBack() {
        gsap.to(item, { opacity: 0.25, duration: 0.5, ease: 'power2.in' });
      },
    });
  });
}

function refreshOnResize(): void {
  let resizeTimer: ReturnType<typeof setTimeout>;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 200);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initPartnersListing();
  refreshOnResize();
});